import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

const PartnerEncumbrancesHeader: FC = () => {
  const { t } = useTranslate();

  return <h6 className="overline-title-alt mb-2">{t('CoOwnershipDetail')}</h6>;
};

export default PartnerEncumbrancesHeader;
